import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Lock } from 'lucide-react';
export const OfferBlock = () => {
  return <section id="oferta" className="py-16 md:py-24 relative overflow-hidden bg-black scroll-mt-8" data-id="element-119">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-red/20 via-black to-black" data-id="element-120"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-surface/90 border-2 border-brand-red/50 rounded-2xl p-6 sm:p-8 md:p-16 backdrop-blur-md shadow-[0_0_100px_rgba(239,68,68,0.15)]" data-id="element-122">
          <div className="inline-flex items-center gap-2 text-brand-red font-mono mb-5 md:mb-6 uppercase tracking-widest text-xs md:text-sm bg-brand-red/10 px-3 md:px-4 py-1 rounded-full" data-id="element-123">
            <Lock className="w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-124" /> Acceso Inmediato
          </div>

          <h2 className="text-2xl sm:text-3xl md:text-5xl mb-5 md:mb-6 leading-tight px-1" data-id="element-125">
            Salva tu carrera como trader por menos de lo que pierdes en un mal
            trade por no tener stop loss.
          </h2>

          <p className="text-sm sm:text-base md:text-xl text-gray-400 mb-6 md:mb-8" data-id="element-126">
            Obtén acceso inmediato al Plan de Recuperación de las 24 Horas.
          </p>

          <div className="mb-8 md:mb-10" data-id="element-127">
            <div className="inline-flex items-center gap-2 bg-brand-red text-white font-mono uppercase text-[10px] sm:text-xs md:text-sm font-bold tracking-widest px-3 py-1.5 rounded-full mb-4 animate-pulse" data-id="element-128">
              ⚡ Oferta Por Tiempo Limitado · -76%
            </div>
            <span className="text-gray-500 font-mono uppercase text-xs md:text-sm block mb-2" data-id="element-129">
              Precio con Descuento
            </span>
            <div className="flex items-baseline justify-center gap-3 md:gap-4 flex-wrap" data-id="element-130">
              <span className="text-2xl sm:text-3xl md:text-4xl font-display text-gray-500 line-through decoration-brand-red decoration-2" data-id="element-131">
                $27
              </span>
              <span className="text-5xl sm:text-6xl md:text-8xl font-display text-white tracking-tighter text-glow-red" data-id="element-132">
                $6.36
              </span>
            </div>
            <p className="text-brand-green font-mono text-xs md:text-sm mt-3 uppercase tracking-wider" data-id="element-133">
              ✓ Ahorras $20.61 hoy
            </p>
          </div>

          <Button className="w-full md:w-auto text-base sm:text-lg md:text-2xl px-6 sm:px-8 md:px-12 py-5 md:py-6 shadow-2xl shadow-brand-red/50" data-id="element-134">
            ¡QUIERO EL PLAN DE RESCATE AHORA!
          </Button>

          <p className="mt-5 md:mt-6 text-xs md:text-sm text-gray-500 font-mono" data-id="element-135">
            Acceso instantáneo tras el pago. Protege tu capital hoy mismo.
          </p>
        </motion.div>
      </div>
    </section>;
};